import apiClient from '../client';

export default async function getOrderState(processingOrderId: string) {
  return apiClient.processingPaymentFormGetState({
    processing_order_id: processingOrderId,
  });
}
